<glxy-form-field [bottomSpacing]="'none'">
  <glxy-label>{{ placeholderText }}</glxy-label>
  <mat-chip-grid #chipGrid>
    <mat-chip-row *ngFor="let option of selected" (removed)="deselectOption(option)">
      {{ optionText(option) }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-row>
    <input [matChipInputFor]="chipGrid" [matAutocomplete]="auto" [formControl]="inputControl" />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions" [value]="option">
      <ng-container
        [ngTemplateOutlet]="searchFunc ? PlainOption : MatchedOption"
        [ngTemplateOutletContext]="{ option: option }"
      />
    </mat-option>
  </mat-autocomplete>
</glxy-form-field>

<ng-template #PlainOption let-option="option">
  <span>{{ optionText(option) }}</span>
</ng-template>

<ng-template #MatchedOption let-option="option">
  <span>{{ optionTextPreMatch(option) }}</span>
  <span class="underline-text">{{ optionTextMatch(option) }}</span>
  <span>{{ optionTextPostMatch(option) }}</span>
</ng-template>
